import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useApp } from 'context/AppContext';
import { NavContainer, NavTab } from './Styles';

const SecondaryNav = () => {
  const { setStoreType } = useApp();
  const location = useLocation();

  const [activeTab, setActiveTab] = useState('special');

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const tabParam = searchParams.get('tab');

    if (tabParam === 'offer') {
      setStoreType('BP');
      setActiveTab('offer');
    } else {
      setStoreType('E');
      setActiveTab('special');
    }

    return () => {
      setStoreType('E');
    };
  }, [setStoreType, location.search]);

  const handleTabClick = (tab, storeType) => {
    setActiveTab(tab);
    setStoreType(storeType);
  };

  return (
    <NavContainer>
      <NavTab $isActive={activeTab === 'special'} onClick={() => handleTabClick('special', 'E')}>
        Special Price
      </NavTab>
      <NavTab $isActive={activeTab === 'offer'} onClick={() => handleTabClick('offer', 'BP')}>
        Offers
      </NavTab>
    </NavContainer>
  );
};

export default SecondaryNav;
